
export default [
  {
    path: '/admin/payment-method-mappings',
    name: 'payment-method-mapping',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/payment-method-mapping')
  }
]
